import React from 'react';
import '../../CSS/layout/Header.css';
import logo from "../../resource/water_logo(black).png";

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-inner">

                <div className="footer-top">
                    <div className="footer-logo">
                        <img src={logo} alt="물조은펜션 로고" />
                    </div>
                    <div className="footer-contact">
                        <p className="footer-contact-phone">010-2180-7979 &nbsp;·&nbsp; 010-7447-9222</p>
                        <p className="footer-contact-addr">경상북도 포항시 북구 죽장면 죽장로 2900</p>
                    </div>
                </div>

                <div className="footer-divider" />

                <p className="footer-meta">
                    대표자 윤정아&nbsp;&nbsp;·&nbsp;&nbsp;사업자등록번호 365-30-01621&nbsp;&nbsp;·&nbsp;&nbsp;농어촌민박 죽장 제2016-02호&nbsp;&nbsp;·&nbsp;&nbsp;계좌 농협 717096-52-186664 (윤정아)
                </p>

                <div className="footer-bottom">
                    <span className="footer-copy">© 2025 물조은펜션. All rights reserved.</span>
                    <div className="footer-links">
                        <a href="#" rel="noopener noreferrer">이용약관</a>
                        <a href="#" rel="noopener noreferrer">개인정보처리방침</a>
                        <a href="#" rel="noopener noreferrer">FAQ</a>
                    </div>
                </div>

            </div>
        </footer>
    );
};

export default Footer;